import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base.service';

export interface ReportedWorkExperience {
  id: number;
  workType: string;
  employerName: string;
  workReferrer: string | null;
  workReferrerOther: string | null;
  createdAt: string;
}

export interface ReportedWorkExperienceResponse {
  reported_work_experiences: ReportedWorkExperience[];
}

@Injectable({
  providedIn: 'root'
})
export class ReportedWorkExperienceService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  createReportedWorkExperience(data: {
    work_type: string;
    employer_name: string;
    work_referrer?: string;
    work_referrer_other?: string;
  }): Observable<any> {
    return this.post<any>('reported-work-experience', data);
  }

  getReportedWorkExperience(): Observable<ReportedWorkExperienceResponse> {
    return this.get<ReportedWorkExperienceResponse>('reported-work-experience');
  }

  updateReportedWorkExperience(id: number, data: {
    work_type: string;
    employer_name: string;
  }): Observable<any> {
    return this.put<any>(`reported-work-experience/${id}`, data);
  }

  removeReportedWorkExperience(id: number): Observable<any> {
    return this.delete<any>(`reported-work-experience/${id}`);
  }
}
